// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PanelDistribucionTelekino_container__jlF\\+m {
  animation: PanelDistribucionTelekino_init__qlIth 1s;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
}

.PanelDistribucionTelekino_container__jlF\\+m .PanelDistribucionTelekino_header__5cmoI {
  animation: PanelDistribucionTelekino_init__qlIth 1.3s;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.PanelDistribucionTelekino_container__jlF\\+m .PanelDistribucionTelekino_header__5cmoI .PanelDistribucionTelekino_arrow__J4i96 {
  transition: 0.3s;
  border-radius: 100%;
}

.PanelDistribucionTelekino_container__jlF\\+m .PanelDistribucionTelekino_header__5cmoI .PanelDistribucionTelekino_arrow__J4i96:hover {
  transition: 0.3s;
  scale: 1.1;
  filter: brightness(1.2);
  background-color: rgba(128, 128, 128, 0.15);
  cursor: pointer;
}

.PanelDistribucionTelekino_container__jlF\\+m .PanelDistribucionTelekino_header__5cmoI .PanelDistribucionTelekino_titleContainer__6f7jV {
  display: flex;
  justify-content: center;
  align-items: center;
}

.PanelDistribucionTelekino_container__jlF\\+m .PanelDistribucionTelekino_header__5cmoI .PanelDistribucionTelekino_titleContainer__6f7jV h4 {
  font-size: 1.5rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
}

.PanelDistribucionTelekino_container__jlF\\+m .PanelDistribucionTelekino_header__5cmoI .PanelDistribucionTelekino_button__g0yqW {
  display: flex;
  justify-content: center;
  align-items: center;
}

.PanelDistribucionTelekino_container__jlF\\+m .PanelDistribucionTelekino_data__THsBA {
  margin-bottom: 100px;
}

/*---Información---*/
.PanelDistribucionTelekino_container__jlF\\+m .PanelDistribucionTelekino_data__THsBA .PanelDistribucionTelekino_tableContainer__myKls {
  animation: PanelDistribucionTelekino_init__qlIth 1.3s;
  border-radius: 5px;
  box-shadow: 0 0 10px -3px rgba(0, 0, 0, 0.268);
}

.PanelDistribucionTelekino_container__jlF\\+m .PanelDistribucionTelekino_data__THsBA .PanelDistribucionTelekino_tableContainer__myKls .PanelDistribucionTelekino_iconbtn__R3eBp {
  transition: 0.3s;
  font-size: 1.5rem;
}

.PanelDistribucionTelekino_container__jlF\\+m .PanelDistribucionTelekino_data__THsBA .PanelDistribucionTelekino_tableContainer__myKls .PanelDistribucionTelekino_iconbtn__R3eBp:hover {
  transition: 0.3s;
  cursor: pointer;
  filter: brightness(0.7);
  scale: 1.04;
}

.PanelDistribucionTelekino_container__jlF\\+m .PanelDistribucionTelekino_linearprogress__sc1Lu p {
  animation: PanelDistribucionTelekino_init__qlIth 1s;
  font-size: 1.5rem;
  font-weight: 300;
}

@keyframes PanelDistribucionTelekino_init__qlIth {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/ProcessFiles/PanelDistribucionTelekino/PanelDistribucionTelekino.module.css"],"names":[],"mappings":"AAAA;EACE,mDAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qDAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,qDAAoB;EACpB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mDAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n}\n\n.container .header {\n  animation: init 1.3s;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .header .arrow {\n  transition: 0.3s;\n  border-radius: 100%;\n}\n\n.container .header .arrow:hover {\n  transition: 0.3s;\n  scale: 1.1;\n  filter: brightness(1.2);\n  background-color: rgba(128, 128, 128, 0.15);\n  cursor: pointer;\n}\n\n.container .header .titleContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 1.5rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n}\n\n.container .header .button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .data {\n  margin-bottom: 100px;\n}\n\n/*---Información---*/\n.container .data .tableContainer {\n  animation: init 1.3s;\n  border-radius: 5px;\n  box-shadow: 0 0 10px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .data .tableContainer .iconbtn {\n  transition: 0.3s;\n  font-size: 1.5rem;\n}\n\n.container .data .tableContainer .iconbtn:hover {\n  transition: 0.3s;\n  cursor: pointer;\n  filter: brightness(0.7);\n  scale: 1.04;\n}\n\n.container .linearprogress p {\n  animation: init 1s;\n  font-size: 1.5rem;\n  font-weight: 300;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PanelDistribucionTelekino_container__jlF+m`,
	"init": `PanelDistribucionTelekino_init__qlIth`,
	"header": `PanelDistribucionTelekino_header__5cmoI`,
	"arrow": `PanelDistribucionTelekino_arrow__J4i96`,
	"titleContainer": `PanelDistribucionTelekino_titleContainer__6f7jV`,
	"button": `PanelDistribucionTelekino_button__g0yqW`,
	"data": `PanelDistribucionTelekino_data__THsBA`,
	"tableContainer": `PanelDistribucionTelekino_tableContainer__myKls`,
	"iconbtn": `PanelDistribucionTelekino_iconbtn__R3eBp`,
	"linearprogress": `PanelDistribucionTelekino_linearprogress__sc1Lu`
};
export default ___CSS_LOADER_EXPORT___;
